module.exports = __webpack_public_path__ + "static/media/calendar.f12dcb54.svg";